module.exports = __webpack_public_path__ + "img/293.4689f8fb.jpg";